import { RouteDetail } from "../../RouteDetail";
import { SectionMenu } from "..";
import { collectionTabs } from "../../../consts/tabs";
import { memo } from "react";

export const CollectionSections = memo(() => {
  return (
    <SectionMenu tabs={collectionTabs} activeTab={0}>
      <SectionMenu.SectionMenuItem id={0}>
        <RouteDetail />
      </SectionMenu.SectionMenuItem>
      <SectionMenu.SectionMenuItem id={1}>
        <RouteDetail />
      </SectionMenu.SectionMenuItem>
    </SectionMenu>
  );
});
